/**
 * @generated SignedSource<<df9d381f27e0d410aebd424d0d3dc5e8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type composerImportAttributeDialogAttributesQuery$variables = {
  modelId: string;
};
export type composerImportAttributeDialogAttributesQuery$data = {
  readonly model: {
    readonly attributes: ReadonlyArray<{
      readonly attributeCode: string | null;
      readonly attributeGuid: any;
      readonly attributeID: number | null;
      readonly attributeTypeID: number;
      readonly defaultValue: string | null;
      readonly description: string | null;
      readonly displayOrder: number;
      readonly groupGuid: any;
      readonly groupID: number;
      readonly hideOptionsLabel: boolean;
      readonly id: string;
      readonly meshSelector: string | null;
      readonly name: string | null;
      readonly optionPreviewShapeID: number;
      readonly options: ReadonlyArray<{
        readonly actions: ReadonlyArray<{
          readonly actionGuid: any;
          readonly actionID: number;
          readonly actionTypeID: number;
          readonly deviceTypes: number;
          readonly execOrder: number;
          readonly name: string | null;
          readonly propertyName: string | null;
          readonly sceneElementTypeID: number;
          readonly selector: string | null;
          readonly value: string | null;
        } | null> | null;
        readonly constraintExpression: {
          readonly op: string | null;
          readonly propositions: ReadonlyArray<{
            readonly attributeGuid: any;
            readonly op: string | null;
            readonly value: string | null;
          } | null> | null;
        } | null;
        readonly description: string | null;
        readonly displayOrder: number;
        readonly extensionFields: ReadonlyArray<{
          readonly dataTypeID: number;
          readonly extensionFieldID: number;
          readonly formatString: string | null;
          readonly label: string | null;
          readonly name: string | null;
          readonly operationTypeID: number;
          readonly value: string | null;
        } | null> | null;
        readonly imageFileObjectID: number;
        readonly imageUrl: string | null;
        readonly isDefault: boolean;
        readonly name: string | null;
        readonly optionCode: string | null;
        readonly optionGuid: any;
        readonly optionID: number | null;
        readonly tempImageFileKey: string | null;
        readonly tempImageFileObjectID: number;
        readonly tempImageUrl: string | null;
      } | null> | null;
      readonly postActions: ReadonlyArray<{
        readonly actionGuid: any;
        readonly actionID: number;
        readonly actionTypeID: number;
        readonly deviceTypes: number;
        readonly execOrder: number;
        readonly name: string | null;
        readonly propertyName: string | null;
        readonly sceneElementTypeID: number;
        readonly selector: string | null;
        readonly value: string | null;
      } | null> | null;
      readonly preActions: ReadonlyArray<{
        readonly actionGuid: any;
        readonly actionID: number;
        readonly actionTypeID: number;
        readonly deviceTypes: number;
        readonly execOrder: number;
        readonly name: string | null;
        readonly propertyName: string | null;
        readonly sceneElementTypeID: number;
        readonly selector: string | null;
        readonly value: string | null;
      } | null> | null;
      readonly sceneCameraLocationID: any | null;
      readonly stepGuid: any;
      readonly stepID: number;
      readonly valueActions: ReadonlyArray<{
        readonly actionGuid: any;
        readonly actionID: number;
        readonly actionTypeID: number;
        readonly deviceTypes: number;
        readonly execOrder: number;
        readonly name: string | null;
        readonly propertyName: string | null;
        readonly sceneElementTypeID: number;
        readonly selector: string | null;
        readonly value: string | null;
      } | null> | null;
    }>;
  } | null;
};
export type composerImportAttributeDialogAttributesQuery = {
  response: composerImportAttributeDialogAttributesQuery$data;
  variables: composerImportAttributeDialogAttributesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "modelId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "modelId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "attributeGuid",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayOrder",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "op",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v9 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "actionID",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "actionGuid",
    "storageKey": null
  },
  (v5/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "actionTypeID",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sceneElementTypeID",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "selector",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "propertyName",
    "storageKey": null
  },
  (v8/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "execOrder",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "deviceTypes",
    "storageKey": null
  }
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Attribute",
  "kind": "LinkedField",
  "name": "attributes",
  "plural": true,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "attributeID",
      "storageKey": null
    },
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "attributeCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "attributeTypeID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultValue",
      "storageKey": null
    },
    (v4/*:: as any*/),
    (v5/*:: as any*/),
    (v6/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "groupID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "groupGuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stepID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stepGuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "optionPreviewShapeID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AttributeOption",
      "kind": "LinkedField",
      "name": "options",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "optionID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "optionGuid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "optionCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tempImageFileKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tempImageUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tempImageFileObjectID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageFileObjectID",
          "storageKey": null
        },
        (v5/*:: as any*/),
        (v6/*:: as any*/),
        (v4/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isDefault",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AttributeExpression",
          "kind": "LinkedField",
          "name": "constraintExpression",
          "plural": false,
          "selections": [
            (v7/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "AttributeProposition",
              "kind": "LinkedField",
              "name": "propositions",
              "plural": true,
              "selections": [
                (v3/*:: as any*/),
                (v7/*:: as any*/),
                (v8/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AttributeSceneAction",
          "kind": "LinkedField",
          "name": "actions",
          "plural": true,
          "selections": (v9/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AttributeOptionExtensionField",
          "kind": "LinkedField",
          "name": "extensionFields",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "extensionFieldID",
              "storageKey": null
            },
            (v8/*:: as any*/),
            (v5/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "label",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "formatString",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "dataTypeID",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "operationTypeID",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AttributeSceneAction",
      "kind": "LinkedField",
      "name": "preActions",
      "plural": true,
      "selections": (v9/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AttributeSceneAction",
      "kind": "LinkedField",
      "name": "valueActions",
      "plural": true,
      "selections": (v9/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AttributeSceneAction",
      "kind": "LinkedField",
      "name": "postActions",
      "plural": true,
      "selections": (v9/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meshSelector",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sceneCameraLocationID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hideOptionsLabel",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "composerImportAttributeDialogAttributesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "model",
        "plural": false,
        "selections": [
          (v10/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "composerImportAttributeDialogAttributesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "model",
        "plural": false,
        "selections": [
          (v10/*:: as any*/),
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2b1b0a243bacb32007eec739c67a3aa1",
    "id": null,
    "metadata": {},
    "name": "composerImportAttributeDialogAttributesQuery",
    "operationKind": "query",
    "text": "query composerImportAttributeDialogAttributesQuery(\n  $modelId: ID!\n) {\n  model(id: $modelId) {\n    attributes {\n      id\n      attributeID\n      attributeGuid\n      attributeCode\n      attributeTypeID\n      defaultValue\n      displayOrder\n      name\n      description\n      groupID\n      groupGuid\n      stepID\n      stepGuid\n      optionPreviewShapeID\n      options {\n        optionID\n        optionGuid\n        optionCode\n        tempImageFileKey\n        tempImageUrl\n        imageUrl\n        tempImageFileObjectID\n        imageFileObjectID\n        name\n        description\n        displayOrder\n        isDefault\n        constraintExpression {\n          op\n          propositions {\n            attributeGuid\n            op\n            value\n          }\n        }\n        actions {\n          actionID\n          actionGuid\n          name\n          actionTypeID\n          sceneElementTypeID\n          selector\n          propertyName\n          value\n          execOrder\n          deviceTypes\n        }\n        extensionFields {\n          extensionFieldID\n          value\n          name\n          label\n          formatString\n          dataTypeID\n          operationTypeID\n        }\n      }\n      preActions {\n        actionID\n        actionGuid\n        name\n        actionTypeID\n        sceneElementTypeID\n        selector\n        propertyName\n        value\n        execOrder\n        deviceTypes\n      }\n      valueActions {\n        actionID\n        actionGuid\n        name\n        actionTypeID\n        sceneElementTypeID\n        selector\n        propertyName\n        value\n        execOrder\n        deviceTypes\n      }\n      postActions {\n        actionID\n        actionGuid\n        name\n        actionTypeID\n        sceneElementTypeID\n        selector\n        propertyName\n        value\n        execOrder\n        deviceTypes\n      }\n      meshSelector\n      sceneCameraLocationID\n      hideOptionsLabel\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9a61cfe51db56e6a21e67679c702168f";

export default node;
